import api from "./api";

export const getProducts = () => {
    return api.get("/products");
};

export const getProduct = (id) => {
    return api.get(`/products/${id}`);
};

export const createProduct = (formData) => {
    return api.post("/products", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

export const updateProduct = (id, formData) => {
    return api.put(`/products/${id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

export const deleteProduct = (id) => {
    return api.delete(`/products/${id}`);
};

export const importProductsCSV = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return api.post("/products/import-csv", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
